import { boolean, Infer, optional, string, type } from "superstruct";
import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";

const UpsertWebhookConfigRequestStruct = type({
  /**
   * Organization ID to configure webhook for.
   */
  organizationId: string(),
  /**
   * The URL to send webhook events to.
   */
  url: string(),
  /**
   * The bearer token for authentication.
   * Provided by the customer - this is the token their endpoint expects.
   */
  bearerToken: string(),
  /**
   * Whether the webhook is enabled. Defaults to true.
   */
  enabled: optional(boolean()),
});

const UpsertWebhookConfigResponseStruct = type({
  /**
   * The webhook config ID.
   */
  webhookConfigId: string(),
});

export type UpsertWebhookConfigRequest = Infer<
  typeof UpsertWebhookConfigRequestStruct
>;
export type UpsertWebhookConfigResponse = Infer<
  typeof UpsertWebhookConfigResponseStruct
>;

export const upsertWebhookConfigDefinition = getFirebaseFunctionDefinition({
  path: "/webhooks/upsert-config",
  reqType: UpsertWebhookConfigRequestStruct,
  resType: UpsertWebhookConfigResponseStruct,
});
